import React from 'react';
import PropTypes from 'prop-types';

const IssueLinkedEntitiesCellItem = ({ entity }) => {
  return <span>{entity.title}</span>;
};

IssueLinkedEntitiesCellItem.propTypes = {
  /**
   * The issue entity we need to render.
   */
  entity: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    displayId: PropTypes.number.isRequired
  }).isRequired
};

export default IssueLinkedEntitiesCellItem;
